import { isOrientationLockAvailable } from './orientation';
import DeviceHelper from './device';

export const getIsFullscreenEnabled = () => {

	const isFullscreenEnabled = document.fullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement || document.webkitIsFullScreen || document.fullscreen;

	if (isFullscreenEnabled) {
		return true;
	}

	return false;
};

export const enableFullscreen = async (element) => {

	//The Web API window.screen.orientation.lock() isn't currently available in Safari on iOS. Date: 29th April, 2024.
	//https://caniuse.com/mdn-api_screenorientation_lock
	//https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation/lock

	if (DeviceHelper.isMobile) {

		if (!element) {
			element = document.getElementById('root');
		}

		const requestFullscreen = element.requestFullscreen || element.webkitRequestFullscreen;

		if (requestFullscreen && typeof requestFullscreen === 'function') {

			const isFullscreenEnabled = getIsFullscreenEnabled();
			const orientationLockAvailable = isOrientationLockAvailable();

			//Only enable fullscreen mode on mobile and when the browser supports orientation lock
			if (!isFullscreenEnabled && orientationLockAvailable) {
				const parameters = {navigationUI: 'hide'};

				try {
					let result;

					if (element.requestFullscreen) {
						result = element.requestFullscreen(parameters);
					}
					else if (element.webkitRequestFullscreen) {
						result = element.webkitRequestFullscreen(parameters);
					}

					//According to documentation, the function requestFullscreen and webkitRequestFullscreen
					//can return a Promise or not
					//https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen
					if (result && typeof result.catch === 'function' && typeof result.then === 'function') {
						await result;
					}

					return true;
				}
				catch (e) {
				}
			}
		}
	}

	return false;
};

export const exitFullscreen = async () => {
	if (getIsFullscreenEnabled()) {
		let result;

		if (document.exitFullscreen && typeof document.exitFullscreen === 'function') {
			result = document.exitFullscreen();
		}
		else if (document.webkitExitFullscreen && typeof document.webkitExitFullscreen === 'function') {
			result = document.webkitExitFullscreen();
		}

		//According to documentation, the function exitFullscreen and webkitExitFullscreen
		//can return a Promise or not
		//https://developer.mozilla.org/en-US/docs/Web/API/Document/exitFullscreen
		if (result && typeof result.then === 'function') {
			await result;
		}
	}
};


// WEBPACK FOOTER //
// ./src/functions/fullscreen.js